import { FunctionComponent, ReactElement } from 'react';
import { MessageDescriptor } from 'react-intl';

import { SafeFormattedMessageWithoutSpread } from '../../../../formatters';

import {
  $FilterContent,
  $FilterContentRightBlock,
  $FilterMenuContainer,
  $FilterSelectedDatePicker,
  $FilterSelectedValues,
  $FilterWrapper,
} from './DatatableFiltersItem.styles';

interface DatatableFiltersModelProps {
  title: string | MessageDescriptor;
  tag: ReactElement;
  filterContent: ReactElement;
  hasPaddingX?: boolean;
}

const DatatableFiltersModel: FunctionComponent<DatatableFiltersModelProps> = ({
  title,
  hasPaddingX = false,
  tag,
  filterContent,
}) => {
  return (
    <$FilterWrapper>
      <$FilterContent>
        <$FilterSelectedValues>
          <SafeFormattedMessageWithoutSpread message={title} />
        </$FilterSelectedValues>

        <$FilterContentRightBlock>{tag}</$FilterContentRightBlock>
      </$FilterContent>

      <$FilterSelectedDatePicker>
        <$FilterMenuContainer $hasPaddingX={hasPaddingX}>
          {filterContent}
        </$FilterMenuContainer>
      </$FilterSelectedDatePicker>
    </$FilterWrapper>
  );
};

export default DatatableFiltersModel;
